import { Component } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';

/** Blank text counts as missing (the dialog trims before it hands over). */
const requiredNonBlank: ValidatorFn = (control) =>
  typeof control.value === 'string' && control.value.trim() === '' ? { required: true } : null;

/**
 * „Moodle-Kurs mit KI" (Creator › Neuer Kurs › Moodle-Kurs): asks for name and
 * description first — like „Neue Übung" — and hands them to the canvas, which
 * fills the course with them and starts the structure right away
 * (`/creator/workspace?mode=course&title=…&description=…`).
 */
@Component({
  selector: 'app-creator-moodle-dialog',
  templateUrl: './creator-moodle-dialog.component.html',
  styleUrl: './creator-moodle-dialog.component.scss',
})
export class CreatorMoodleDialogComponent {
  readonly form = new FormGroup({
    title: new FormControl<string>('', { nonNullable: true, validators: [requiredNonBlank, Validators.maxLength(200)] }),
    description: new FormControl<string>('', { nonNullable: true, validators: [requiredNonBlank] }),
    learningGoals: new FormControl<string>('', { nonNullable: true }),
    // the canvas course artifact's values
    difficultyLevel: new FormControl<'EASY' | 'MEDIUM' | 'HARD'>('MEDIUM', { nonNullable: true }),
  });

  constructor(
    private ref: NbDialogRef<CreatorMoodleDialogComponent>,
    private router: Router,
  ) {}

  cancel(): void {
    this.ref.close();
  }

  start(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;
    const value = this.form.getRawValue();
    const queryParams: Record<string, string> = {
      mode: 'course',
      title: value.title.trim(),
      description: value.description.trim(),
      difficultyLevel: value.difficultyLevel,
    };
    if (value.learningGoals.trim()) queryParams['learningGoals'] = value.learningGoals.trim();
    this.ref.close();
    this.router.navigate(['/creator/workspace'], { queryParams });
  }
}
